import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaShoppingCart, FaBoxOpen, FaHome, FaCreditCard, FaRupeeSign, FaUsers, FaUser } from "react-icons/fa";
import Swal from 'sweetalert2';

function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const userId = localStorage.getItem('user_id');

  // Function to check if user has completed at least one order
  const checkUserOrders = async () => {
    const authToken = localStorage.getItem("authToken");
    try {
      const response = await fetch(`${process.env.REACT_APP_HOST}api/orders/userOrders?user_id=${userId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = await response.json();

      if (data.success && Array.isArray(data.data) && data.data.length > 0) {
        return true; // User has orders
      } else {
        Swal.fire({
          imageUrl: "/shop/images/Ordernotfound.svg",
          imageWidth: '100%',
          imageHeight: 'auto',
          imageAlt: "Order Not Found",
          title: 'Access Restricted',
          text: 'You need to complete at least one purchase to access this feature.',
          timer: 5000,
          timerProgressBar: true,
          showConfirmButton: false
        });
        return false; // User has no orders
      }
    } catch (err) {
      console.error("Error fetching orders:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again.",
        showConfirmButton: false
      });
      return false;
    }
  };

  const handleTeamClick = async (e) => {
    e.preventDefault();
    const hasOrders = await checkUserOrders();
    if (hasOrders) {
      navigate("/shop/auths/user-profile-page?tab=tabThree");
    }
  };

  const handlePayoutsClick = async (e) => {
    e.preventDefault();
    const hasOrders = await checkUserOrders();
    if (hasOrders) {
      navigate("/shop/auths/user-profile-page?tab=tabTwo");
    }
  };

  const handleProfileClick = async (e) => {
    e.preventDefault();
    const hasOrders = await checkUserOrders();
    if (hasOrders) {
      navigate("/shop/auths/user-profile-page");
    }
  };

  return (
    <div>
      {/* Desktop View Footer */}
      <div
        className="nk-footer d-none d-md-block"
        style={{
          marginBottom: "-50px",
          backgroundColor: "#ffffff",
          color: "#000000",
          position: "absolute",
          bottom: 0,
          width: "100%",
          zIndex: 100,
          padding: "10px 0",
        }}
      >
        <div className="container-fluid">
          <div className="nk-footer-wrap d-flex flex-column flex-md-row justify-content-center align-items-center text-center text-md-start">
            <div className="nk-footer-copyright">
              &copy; 2025 - All rights Reserved{" "}
              <a
                href="https://7crore.com/"
                target="_blank"
                rel="noreferrer"
                style={{ color: "inherit", textDecoration: "none" }}
              >
                Elite World
              </a>
            </div>
            <div
              className="nk-footer-powered ms-md-3 mt-2 mt-md-0"
              style={{ color: "inherit" }}
            >
              Powered By{" "}
              <a
                href="https://7crore.com/"
                target="_blank"
                rel="noreferrer"
                style={{ color: "inherit", textDecoration: "none" }}
              >
                7 Crore Technologies
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile View Footer */}
      <div
        className="nk-footer-mobile d-md-none"
        style={{
          backgroundColor: "#ffffff",
          color: "#000000",
          padding: "10px 0",
          textAlign: "center",
          position: "fixed",
          bottom: 0,
          width: "100%",
          zIndex: 100,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          <Link
            to="/shop"
            className="nk-footer-link"
            style={{
              color: "#000000",
              textDecoration: "none",
              textAlign: "center",
            }}
          >
            <FaHome size={20} style={{ marginBottom: "5px" }} />
            <div>Home</div>
          </Link>

          <a
            href="#"
            className="nk-footer-link"
            onClick={handlePayoutsClick}
            style={{
              color: "#000000",
              textDecoration: "none",
              textAlign: "center"
            }}
          >
            <FaRupeeSign size={20} style={{ marginBottom: "5px" }} />
            <div>Payouts</div>
          </a>

          <a
            href="#"
            className="nk-footer-link"
            onClick={handleTeamClick}
            style={{
              color: "#000000",
              textDecoration: "none",
              textAlign: "center"
            }}
          >
            <FaUsers size={20} style={{ marginBottom: "5px" }} />
            <div>Team</div>
          </a>

          <Link
            to="/shop/auths/orders"
            className="nk-footer-link"
            style={{
              color: "#000000",
              textDecoration: "none",
              textAlign: "center",
            }}
          >
            <FaBoxOpen size={20} style={{ marginBottom: "5px" }} />
            <div>Orders</div>
          </Link>

          <a
            href="#"
            className="nk-footer-link"
            onClick={handleProfileClick}
            style={{
              color: "#000000",
              textDecoration: "none",
              textAlign: "center",
            }}
          >
            <FaUser size={20} style={{ marginBottom: "5px" }} />
            <div>Profile</div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer;